import React from 'react';
import { SxProps, Theme, Typography } from '@mui/material';

type MultilineTextProps = {
  className?: string;
  children: React.ReactNode;
  maxLines: number;
  sx?: SxProps<Theme>;
};

export const MultilineText = (props: MultilineTextProps) => {
  const overflowStyle = {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: '-webkit-box',
    WebkitLineClamp: `${props.maxLines}`,
    WebkitBoxOrient: 'vertical',
  };
  const style = props.sx ? { ...props.sx, ...overflowStyle } : overflowStyle;
  return (
    <Typography className={props.className} component='p' sx={style}>
      {props.children}
    </Typography>
  );
};
